import { Component, Input } from '@angular/core';
import { ClubModel } from '../../../core/models/app.models';

@Component({
  selector: 'app-club-logo',
  template: `
    <div class="club-logo-wrapper" [style.width]="size" [style.height]="size">
      <img *ngIf="club?.logoUrl" [src]="club?.logoUrl" [alt]="club?.name" class="logo-img shadow-1" />
      
      <div *ngIf="!club?.logoUrl" class="generic-crest shadow-1">
        <svg viewBox="0 0 100 100" class="crest-svg" xmlns="http://www.w3.org/2000/svg">
          <!-- Čistý kruhový podklad -->
          <circle cx="50" cy="50" r="48" fill="#f1f5f9" stroke="#e2e8f0" stroke-width="2"/>
          
          <!-- Abstraktní geometrický vzor připomínající dres/vlajku -->
          <path d="M20 30 L80 30 L80 70 L20 70 Z" fill="white" opacity="0.5"/>
          <path d="M20 45 L80 45 L80 55 L20 55 Z" fill="#cbd5e1"/>
          <path d="M45 30 L55 30 L55 70 L45 70 Z" fill="#cbd5e1"/>
          
          <!-- Decentní vnější prstenec -->
          <circle cx="50" cy="50" r="42" fill="none" stroke="#cbd5e1" stroke-width="1" stroke-dasharray="4 2"/>
        </svg>
      </div>
    </div>
  `,
  styles: [`
    .club-logo-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }
    .logo-img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: 50%;
      background: white;
    }
    .generic-crest {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .crest-svg {
      width: 100%;
      height: 100%;
    }
  `]
})
export class ClubLogoComponent {
  @Input() club?: ClubModel;
  @Input() size: string = '2.5rem';
}
